import { NgModule } from '@angular/core';

// Modules
import { GroupsSharedModule } from '@app/groups/groups-shared.module';
import { InsightsModule } from '@app/insights/insights.module';
import { LayoutModule } from '@app/layout/layout.module';
import { MarkdownModule } from '@app/markdown/markdown.module';
import { OrgsSharedModule } from '@app/orgs/orgs-shared.module';
import { SharedModule } from '@app/shared/shared.module';
import { SkillStandardsSharedModule } from '@app/skill-standards/skill-standards-shared.module';
import { TagsModule } from '@app/tags/tags.module';
import { TargetModule } from '@app/target/target.module';
import { DfFormlyModule } from '@lib/fresco';
import { SwiperModule } from 'swiper/angular';
import { ResourceLauncherModule } from '@app/resource-launcher/resource-launcher.module';
import { RouterModule } from '@angular/router';
import { AddBySearchModule } from '@app/search/components/add-by-search/add-by-search.module';

// Flex framework
import { FlexInsightsViewComponent } from '@app/flex-framework/components/flex-insights-view/flex-insights-view.component';
import { FlexMetaDataComponent } from '@app/flex-framework/components/flex-meta-data/flex-meta-data.component';
import { FlexRowHeaderComponent } from '@app/flex-framework/components/flex-row-header/flex-row-header.component';
import { FlexRowComponent } from '@app/flex-framework/components/flex-row/flex-row.component';
import { FlexViewHeaderComponent } from '@app/flex-framework/components/flex-view-header/flex-view-header.component';
import { LinkTextRowComponent } from '@app/flex-framework/components/link-text-row/link-text-row.component';
import { AddResourcesModal } from '@app/flex-framework/components/modals/add-resources-modal/add-resources-modal.component';
import { MetaDataModal } from '@app/flex-framework/components/modals/meta-data-modal/meta-data-modal.component';
import { CarouselContentComponent } from './components/carousel/carousel-content.component';
import { CarouselHeaderComponent } from './components/carousel/carousel-header.component';
import { FlexGridComponent } from './components/flex-grid/flex-grid.component';
import { FlexProviderCardComponent } from './components/flex-provider-card/flex-provider-card.component';
import { FreeTextRowComponent } from './components/free-text-row/free-text-row.component';
import { TargetResourcesModal } from './components/modals/target-resources-modal/target-resources-modal.component';
import { TargetResourceListItemComponent } from './components/target-resource-list-item/target-resource-list-item.component';
import { NavigationModule } from '@app/navigation/navigation.module';
import { TargetAddByTypeComponent } from './components/modals/add-resources-modal/components/target-add-by-type/target-add-by-type.component';

@NgModule({
  declarations: [
    AddResourcesModal,
    FlexInsightsViewComponent,
    LinkTextRowComponent,
    FlexMetaDataComponent,
    FlexRowComponent,
    FlexRowHeaderComponent,
    FlexViewHeaderComponent,
    MetaDataModal,
    CarouselContentComponent,
    CarouselHeaderComponent,
    FreeTextRowComponent,
    TargetAddByTypeComponent,
    TargetResourcesModal,
    TargetResourceListItemComponent,
    FlexGridComponent,
    FlexProviderCardComponent,
  ],
  imports: [
    AddBySearchModule,
    DfFormlyModule,
    InsightsModule,
    GroupsSharedModule,
    LayoutModule,
    MarkdownModule,
    NavigationModule,
    OrgsSharedModule,
    SharedModule,
    SkillStandardsSharedModule,
    SwiperModule,
    TagsModule,
    TargetModule,
    RouterModule,
    ResourceLauncherModule,
  ],
  exports: [
    AddResourcesModal,
    FlexInsightsViewComponent,
    FlexRowComponent,
    FlexViewHeaderComponent,
    FreeTextRowComponent,
    TargetResourceListItemComponent,
    CarouselContentComponent,
    CarouselHeaderComponent,
    FlexProviderCardComponent,
  ],
  providers: [],
})
export class FlexFrameworkSharedModule {}
